import { render, staticRenderFns } from "./QTicketCommentList.vue?vue&type=template&id=96707ab8&"
import script from "./QTicketCommentList.vue?vue&type=script&lang=js&"
export * from "./QTicketCommentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports